import { Component, Input, OnInit } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'cap-beschreibung-table-wrapper',
  templateUrl: './beschreibung-table-wrapper.component.html',
  styleUrls: ['./beschreibung-table-wrapper.component.scss'],
  imports: [NgClass]
})
export class BeschreibungTableWrapperComponent implements OnInit {
  @Input()
  tableFullWidth = false;

  tableSizeClass;
  tableTitleSizeClass;

  constructor() {}

  ngOnInit() {
    this.tableTitleSizeClass = this.tableFullWidth ? 'col-lg-12' : 'col-lg-2';
    this.tableSizeClass = this.tableFullWidth ? 'col-lg-12' : 'col-lg-10';
  }
}
